import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CustomRoute } from '@/components/functional/Link/CustomRoute';
import { CustomRoutes } from '@/components/functional/Link/CustomRoutes';
import { ColumnList } from '@/container/Column/List';
import { ClientSeminarList } from '@/container/Seminar/List';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useArticleListFetchCount } from '@/pages/article/ArticleList/useArticleListFetchCount';
import { CaseList } from '@/pages/case/CaseList';
import { ARTICLE_PAGE_TYPE_CASE_STUDY, ARTICLE_PAGE_TYPE_COLUMN, ARTICLE_PAGE_TYPE_DOCUMENT, } from '@/utils/constants/article/articleType';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 各種記事系一覧ページのアクセスルーティング用
 */
export const ArticleListRoot = () => {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    // 件数タブリンク表示用のデータ
    const { articleLinkListItems } = useArticleListFetchCount({
        dispatch,
        pathname,
        unmountRef,
    });
    return (_jsxs(CustomRoutes, { children: [_jsx(CustomRoute, { element: _jsx(CaseList, { articleLinkListItems: articleLinkListItems }), path: pagePath.case.list() }), _jsx(CustomRoute, { element: _jsx(ColumnList, { articleLinkListItems: articleLinkListItems, description: META_DESCRIPTION.documentList(), headTitle: '資料', title: 'ダウンロード資料', types: ARTICLE_PAGE_TYPE_DOCUMENT }), path: pagePath.document.list() }), _jsx(CustomRoute, { element: _jsx(ColumnList, { articleLinkListItems: articleLinkListItems, description: META_DESCRIPTION.columnList(), title: 'コラム', types: `${ARTICLE_PAGE_TYPE_COLUMN},${ARTICLE_PAGE_TYPE_CASE_STUDY}` }), path: pagePath.column.list() }), _jsx(CustomRoute, { element: _jsx(ClientSeminarList, { articleLinkListItems: articleLinkListItems }), path: pagePath.seminar.list() })] }));
};
